import PropTypes from "prop-types";

/** Website provider dropdown with its hint, plus a free-text field when "Other" is picked. */
function ProviderSelect({ id, otherId, options, value, other, hint, error, onChange, onOtherChange }) {
	return (
		<div className="row ao-provider">
			<div className={`field${error ? " field--error" : ""}`}>
				<label className="f req" htmlFor={id}>
					Website provider
				</label>
				<select
					id={id}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					aria-invalid={Boolean(error)}>
					<option value="">Select a provider</option>
					{options.map((option) => (
						<option key={option}>{option}</option>
					))}
				</select>
				<div className="hint">{hint}</div>
				{error && (
					<div className="err" id={`${id}-err`}>
						{error}
					</div>
				)}
			</div>
			{value === "Other" && (
				<div className="field">
					<label className="f" htmlFor={otherId}>
						Which provider?
					</label>
					<input
						type="text"
						id={otherId}
						value={other}
						onChange={(e) => onOtherChange(e.target.value)}
					/>
				</div>
			)}
		</div>
	);
}

ProviderSelect.propTypes = {
	id: PropTypes.string.isRequired,
	otherId: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(PropTypes.string).isRequired,
	value: PropTypes.string.isRequired,
	other: PropTypes.string.isRequired,
	hint: PropTypes.string.isRequired,
	error: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onOtherChange: PropTypes.func.isRequired,
};

export default ProviderSelect;
